import { useState, useEffect } from "react";
import { ReactPhotoEditor } from "react-photo-editor";
import { useSelector } from "react-redux";
import Avatar from "@mui/material/Avatar";
import "./avatar_editor.scss";
import Chip from "@mui/material/Chip";
import { Button } from "@mui/material";

function AvatarEditor({ onImageChange }) {
  const [image_label, setImage_label] = useState("");
  const token = useSelector((state) => state.userSelector.token);
  const [file, setFile] = useState(null);
  const [edit, setEdit] = useState(true);
  const [showModal, setShowModal] = useState(false);
  // Show modal if file is selected
  const showModalHandler = () => {
    if (file) {
      setShowModal(true);
    }
  };

  // Hide modal
  const hideModal = () => {
    setShowModal(false);
  };

  // Save edited image
  const handleSaveImage = (editedFile) => {
    setFile(editedFile);
  };

  const setFileData = (e) => {
    if (e?.target?.files && e.target.files.length > 0) {
      setFile(e.target.files[0]);
      setImage_label(e.target.files[0].name);
      setEdit(false);
    }
  };

  useEffect(() => {
    onImageChange(file);
  }, [file]);

  return (
    <>
      <Chip
        size="medium"
        sx={{ width: "100%" }}
        avatar={<Avatar alt="" src="/static/img/avatar/1.jpg" />}
        label={
          <input
            type="file"
            name="file[]"
            onChange={(e) => setFileData(e)}
            multiple={false}
          />
        }
        variant="outlined"
      />

      <Button onClick={showModalHandler} disabled={edit}>
        Редактировать
      </Button>

      <ReactPhotoEditor
        open={showModal}
        onClose={hideModal}
        file={file}
        onSaveImage={handleSaveImage}
      />
    </>
  );
}

export default AvatarEditor;
